import React from 'react';
import Settings from '../components/Settings';

const SettingsPage = () => {
  return (
    <main className="flex-1 container mx-auto px-4 lg:px-6 py-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">Settings</h1>
        <p className="text-gray-600">Manage assets, market data providers, security, and privacy</p>
      </div>
      <Settings />
    </main>
  );
};

export default SettingsPage;


